// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1dLkX","text-container":"styles_text-container__znGyI"};